

/// <amd-module name="VSS/Redux/Deprecated/HubViewState/HubViewStateSelectors" />
import * as Reselect from "Reselect";
import { IFilterState } from "VSSUI/Utilities/Filter";
import { IHubViewAwareState } from "./HubViewStateContracts";
import { IViewOptionsValues } from "VSSUI/Utilities/ViewOptions";

export function getCurrentPivot(state: IHubViewAwareState): string | undefined {
    if (state && state.hubViewState) {
        return state.hubViewState.currentPivot;
    }
}

/** Determine if the filter is active */
export const isFilterActive = Reselect.createSelector(
    [getCurrentFilterState],
    (filterState: IFilterState | undefined): boolean => {
        let isActive = false;
        if (filterState) {
            for (const key in filterState) {
                const filterItemState = filterState[key];
                if (filterItemState && filterItemState.value && filterItemState.value.length) {
                    isActive = true;
                    break;
                }
            }
        }

        return isActive;
    }
);

export function getCurrentFilterState(state: IHubViewAwareState): IFilterState | undefined {
    if (state && state.hubViewState) {
        return state.hubViewState.currentFilterState;
    }
}

export function getCurrentViewOptions(state: IHubViewAwareState): IViewOptionsValues | undefined {
    if (state && state.hubViewState) {
        return state.hubViewState.currentViewOptions;
    }
}
